<template>
  <AppLayout>
    <MobileLeftNav :nav="nav"></MobileLeftNav>
    <b-row>
      <b-col sm="2" md="3" class="d-none d-sm-block">
        <LeftNav :nav="nav">></LeftNav>
      </b-col>
      <b-col sm="10" md="9">
        <div :class="$route.meta.noBorder ? 'dashboard-bare' : 'dashboard-content p-lg-5 p-3'" v-if="ready">
          <router-view></router-view>
        </div>
      </b-col>
    </b-row>
  </AppLayout>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  import LeftNav from './LeftNav'
  import MobileLeftNav from './MobileLeftNav'

  export default {
    components: {
      LeftNav,
      MobileLeftNav,
    },
    props: {
      children: { type: Array, required: true },
      prefix: { type: String, default: 'dashboard' },
    },
    mounted() {
      this.loadTeamInfo();
    },
    computed: {
      ...mapGetters(['loggedIn', 'teamId']),
      ready() {
        return this.loggedIn && this.teamId;
      },
      nav() {
        // Used by LeftNav and MobileLeftNav etc.
        // derive the nav items from the children automatically,

        return this.children
          .filter(o => (!o.isHidden))
          .map(({path, children, meta={}}) => {
            let to, linkClass, {title, icon, symbol, src} = meta;
            if (!icon && !src && !symbol) icon = 'danger';
            if (path === '/') {
              to = `/${this.prefix}`;
              title = title || 'Dashboard';
            } else {
              // Ignore extra parts of the path, assuming they are optional
              // placeholders (eg name/:foo?)
              // We link to the base part of the path from the Nav, (eg, /dashboard/name)
              // and use the base part to form the title.
              path = path.split('/')[0];
              to = `/${this.prefix}/${path}`;
              title = title || path.substr(0,1).toUpperCase() + path.substr(1);
            }
            // This keeps the nav item selected even when sub-routes are active, eg /dashboard/settings/addresses
            if (children) linkClass = 'non-exact';
            return {to, title, icon, symbol, src, linkClass};
          });
      }
    },
    methods: mapActions(['loadTeamInfo']),
  }
</script>

<<style scoped lang="scss">
@import '~scss/colors';
  .dashboard-content {
    background: $white;
    border:1px solid rgb(192, 192, 192);
  }
  .dashboard-bare {
    // TODO do we need anything here?
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DashboardBase.vue